import { StringUtils } from 'src/app/services/utils/string.utils';

export class OrderDetailsProductObject {

    constructor(private productAction: string, private productName: string, private productId: string) {
        this.productAction = productAction;
        this.productName = productName;
        this.productId = productId;
    }

    public static create(): OrderDetailsProductObject {
        return new OrderDetailsProductObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE);
    }

    public getProductAction() {
        return this.productAction;
    }

    public getProductName() {
        return this.productName;
    }

    public getProductId() {
        return this.productId;
    }
}